import { ids } from '@icarros/theme-react';
import styled, { css } from 'styled-components';

interface ListItemModifierProps {
  highlight?: boolean;
  active?: boolean;
  isCustom?: boolean;
}

export const SidebarWrapper = styled.div`
  display: none;
  visibility: hidden;
  top: 0;
  position: absolute;
  width: 64px;
  height: 100%;
  background-color: white;
  border-right: 1px solid ${ids.color.border.ids_color_border_soft};
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-block: 12px;
  z-index: var(--sidebar-overlay-z);
  transition: all 0.3s ease-in-out;

  > div {
    position: sticky;
    top: 76px;
    margin-block-end: 50px;

    &:nth-of-type(2) {
      margin-block-start: 60%;
      margin-block-end: 0;
      top: 90%;
    }
  }

  button {
    width: 100%;

    div:nth-of-type(1) {
      svg {
        width: 24px;
        height: 24px;
      }
    }

    div:nth-of-type(2) {
      opacity: 0;
      margin-left: 0px;
      transition: all 0.3s ease-in-out;

      span {
        white-space: pre;
      }
    }

    div:nth-of-type(3) {
      display: none;
    }
  }

  + .rebranding-page__container::after {
    content: '';
    position: absolute;
    inset: 0;
    z-index: var(--overlay-z);
    width: 0;
    height: 100%;
    background-color: rgba(0, 0, 0, 0);
    transition: all 0.3s ease-in-out;
  }

  &:hover {
    width: 186px;

    + .rebranding-page__container::after {
      width: 100%;
      background-color: rgba(0, 0, 0, 0.5);
    }

    button div:nth-of-type(2) {
      opacity: 1;
    }
  }

  @media (min-width: 1365px) {
    display: block;
    visibility: visible;
  }
`;

export const ListItemModifier = styled.div<ListItemModifierProps>`
  button {
    border-left: 2px solid transparent;
    gap: 0;
    padding: 0;
  }

  span {
    font-size: 14px;
  }

  ${({ highlight }) =>
    highlight &&
    css`
      margin-bottom: 20px;
    `}

  ${({ active }) =>
    active &&
    css`
      button {
        border-left: 2px solid ${ids.color.action.primary.ids_color_action_primary_base};
      }
    `}

  ${({ active, isCustom }) =>
    active &&
    !isCustom &&
    css`
      svg path {
        fill: ${ids.color.action.primary.ids_color_action_primary_base};
      }
    `}

  ${({ active, isCustom }) =>
    active &&
    isCustom &&
    css`
      svg path {
        stroke: ${ids.color.action.primary.ids_color_action_primary_base};
      }
    `}


  .avatar-icon {
    padding: 8px 16px !important;
  }
`;

export const IconWrapper = styled.div`
  padding: 8px 16px;
`;
